import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Table from "@amzn/meridian/table";
import TableRow from "@amzn/meridian/table/table-row";
import TableCell from "@amzn/meridian/table/table-cell";
import {FormattedMessage} from "react-intl";
import Link from "@amzn/meridian/link";
import {HYPHEN, MISSING} from "../constants";
import Loading from "./utils/Loading";
import ErrorPage from "./utils/ErrorPage";
import {PackageStatus} from "../enums";
import CartStatus from "./floor/CartStatus";
import {chainWalk, formQueryParams} from "../Utility";
import OvCartTableCell from "./floor/OvCartTableCell";
import {getStowCartDataForCartLocation} from "../actions/CartLocationActions";
import RefreshTimer from "./RefreshTimer";
import Column from "@amzn/meridian/column";

class CartLocation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expandedCartLocations: []
        }
    }

    render() {

        const error = this.props.error
        const stowPackageMetricsMap = this.props.stowPackageMetricsMap

        if (error) {
            return <ErrorPage errorId="stow.error" errorMessage="Some error occurred"/>
        }

        const floors = this.getDistinctCartLocations().sort()

        if (this.props.loading && !floors.length) {
            return <Loading/>
        }

        return (
            <Column>
                <RefreshTimer deps={[stowPackageMetricsMap]} />
                <Table headerRows={1} showDividers={false} showStripes={false} spacing="small" fixHeaderRows={true}
                       fixHeaderRowsFullWidth={true}>
                    {this.renderHeadings()}
                    {floors.map((floor) => (this.renderCartLocationRow(floor)))}
                </Table>
            </Column>
        )
    }

    getDistinctCartLocations = () => {
        const allCartLocations = [
            ...Object.keys(this.props.stowCartLocationsData),
            ...Object.keys(this.props.stowPackageMetricsMap)
        ];

        return [...new Set(allCartLocations)];
    }

    renderHeadings = () => {
        return (
            <TableRow>
                <TableCell>
                    <FormattedMessage id="floor.location" defaultMessage="Location"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="floor.inducted" defaultMessage="Inducted"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="floor.stowed" defaultMessage="Stowed"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="floor.problem_solve" defaultMessage="PS"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="floor.stow_rate" defaultMessage="Stow rate"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="floor.scan_compliance" defaultMessage="Scan comp."/>
                </TableCell>
                <TableCell>
                    <FormattedMessage id="floor.cart_status" defaultMessage="Cart status"/>
                </TableCell>
            </TableRow>
        );
    }

    renderCartLocationRow = (floor) => {
        const combinedMetricsMap = this.getCombinedMetricsMap(floor)

        return (
            <TableRow highlightOnHover={true} key={floor} open={this.isCartLocationExpanded(floor)}
                      onClick={() => this.floorRowClicked(floor)}>
                <TableCell>{this.getDisplayLabel(floor)}</TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.inductedPackages, floor, PackageStatus.CURRENT_INDUCTED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.stowedPackages, floor, PackageStatus.STOWED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.problemSolvePackages, floor, PackageStatus.PROBLEM_SOLVE)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.stowRate}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.scanCompliance}
                </TableCell>
                <TableCell>
                    <CartStatus status={combinedMetricsMap.cartStatus}/>
                </TableCell>
                {this.renderCart(floor)}
            </TableRow>
        );
    }

    getCombinedMetricsMap = floor => {
        const {
            stowCartLocationsData,
            stowPackageMetricsMap
        } = this.props;
        const defaultMetricValue = HYPHEN

        return {
            inductedPackages: chainWalk(() => stowPackageMetricsMap[floor].currentInductedPackages, defaultMetricValue),
            stowedPackages: chainWalk(() => stowPackageMetricsMap[floor].stowedPackages, defaultMetricValue),
            problemSolvePackages: chainWalk(() => stowPackageMetricsMap[floor].problemSolvePackages, defaultMetricValue),
            scanCompliance: chainWalk(() => stowPackageMetricsMap[floor].scanCompliance, defaultMetricValue),
            stowRate: chainWalk(() => stowPackageMetricsMap[floor].stowRate, defaultMetricValue),
            cartStatus: chainWalk(() => stowCartLocationsData[floor].cart.status, MISSING)
        }
    }

    getDisplayLabel = (floor) => {
        return chainWalk(() => floor.split(".")[1], floor)
    }

    isCartLocationExpanded = (floor) => {
        return (this.state.expandedCartLocations.indexOf(floor) !== -1);
    }

    renderCart = (floor) => {
        const cart = this.getCart(floor)
        if (cart) {
            return this.renderOvCart(cart)
        }
        return <TableRow/>
    }

    getCart = (floor) => {
        const cartData = this.props.stowCartData;
        if (cartData && cartData[floor]) {
            return cartData[floor]
        }
    }

    renderOvCart = (cart) => {
        return (
            <TableRow>
                <OvCartTableCell cart={cart}/>
            </TableRow>
        )
    }

    renderPackageCount = (value, floor, state) => {
        return value !== 0 && value !== '-' ?
            <Link href={this.getPackageListURL(state, floor)}
                  type="secondary"> {value} </Link> : value
    }

    getPackageListURL = (state, floor) => {
        const params = {
            PACKAGE_STATUS: state,
            AISLE: floor
        }
        return "#packageList/?" + formQueryParams(params);
    }

    floorRowClicked = floor => {
        this.setState((oldState) => {
            if (oldState.expandedCartLocations.indexOf(floor) !== -1) {
                return {
                    expandedCartLocations: oldState.expandedCartLocations.filter(expandedCartLocation => expandedCartLocation !== floor)
                }
            } else {
                this.props.dispatch(getStowCartDataForCartLocation(this.props.nodeId, floor));
                return {
                    expandedCartLocations: oldState.expandedCartLocations.concat(floor)
                }
            }
        })
    }
}

const mapStateToProps = state => ({
    loading: state.cartLocationReducer.loading,
    error: state.cartLocationReducer.error,
    stowCartData: state.cartLocationReducer.stowCartData,
    stowCartLocationsData: state.cartLocationReducer.stowCartLocationsData,
    stowPackageMetricsMap: state.cartLocationReducer.stowPackageMetricsMap,
});
export default withRouter(connect(mapStateToProps)(CartLocation));



// WEBPACK FOOTER //
// ./src/components/CartLocation.js